module.exports = __webpack_public_path__ + "img/gnzs17.0d9e33f9.png";